import React from "react";

import ConfirmationButtons from "../../views/table/ConfirmationButtons";
import { WithBusyIndicator } from "../busyIndicator/withBusyIndicator";
import Dialog, { IDialogProps } from "./Dialog";

interface IProps extends IDialogProps, Pick<WithBusyIndicator, "busy"> {
    confirmText?: string;
    cancelText?: string;
}

export class ConfirmationDialog extends React.PureComponent<IProps> {
    render() {
        return (
                <Dialog {...this.props} isConfirmation
                        footer={<ConfirmationButtons confirmText={this.props.confirmText}
                                                     cancelText={this.props.cancelText}
                                                     onConfirm={this.props.onConfirm} onCancel={this.props.onClose}
                                                     useWrapper={false}/>}>
                    {this.props.children}
                </Dialog>
        );
    }
}